import { forwardRef, InputHTMLAttributes, ReactNode } from "react";
import styles from "./Input.module.scss";

type Props = InputHTMLAttributes<HTMLInputElement> & {
    label: string;
    error?: string;
    icon?: ReactNode;
    inputSize?: "small" | "large" | "full";
    containerClassName?: string;
};

const NO_TRIM_TYPES = new Set(["password", "number", "date", "time"]);

const Input = forwardRef<HTMLInputElement, Props>(({ label, error, icon, id, required, inputSize = "small", containerClassName = "", ...inputProps }, ref) => {
    const inputId = id ?? label.toLowerCase().replace(/\s+/g, "-");
    const { onChange, onBlur: onBlurFromProps, type = "text", ...restInputProps } = inputProps;

    const handleChange = onChange;

    const handleBlur = !NO_TRIM_TYPES.has(type) && onChange
        ? (e: React.FocusEvent<HTMLInputElement>) => {
              const trimmed = e.target.value.trim();
              if (trimmed !== e.target.value) {
                  e.target.value = trimmed;
                  onChange(e as unknown as React.ChangeEvent<HTMLInputElement>);
              }
              onBlurFromProps?.(e);
          }
        : onBlurFromProps;

    return (
        <div className={styles.wrapper}>
            <label className={styles.label} htmlFor={inputId}>
                {label}
                {required && <span className={styles.required}>*</span>}
            </label>

            <div className={`${styles.inputErrorContainer} ${inputSize === "large" ? styles.inputErrorContainerLarge : ""} ${inputSize === "full" ? styles.inputErrorContainerFull : ""}`}>
                
                <div className={`${styles.inputContainer} ${error ? styles.errorBorder : ""} ${containerClassName}`}>
                    {icon && <span className={styles.icon}>{icon}</span>}
                    <input
                        ref={ref}
                        id={inputId}
                        className={styles.input}
                        required={required}
                        type={type}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        {...restInputProps}
                    />
                </div>
                {error && <span className={styles.error}>{error}</span>}
            </div>

        </div>
    );
});

export default Input;
